import React from 'react';

const SpecializedSection = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="grid grid-cols-2 items-start gap-10 pb-50 sm:grid-cols-1 lg:grid-cols-2">
                    <div>
                        <h2 className="mb-0 text-white text-[48px] leading-[64px] font-bold sm:text-3xl md:text-4xl lg:text-[48px] lg:leading-[64px]">
                            Your partner For&nbsp;
                            <br className="hidden lg:block" />
                            <span className="gradient-text">
                                Al, Automation & <br className="hidden lg:block" />
                                Product Engineering
                            </span>
                        </h2>
                    </div>

                    <p className="text-white text-xl leading-[30px] font-normal mb-0 sm:text-base md:text-xl">
                        We help enterprises and SMEs use AI effectively, rebuild complex software systems, and launch scalable
                        digital products. Our team focuses on secure architecture, clean engineering, and dependable delivery.
                        With experience across AI, enterprise platforms, and product development, we support organizations aiming
                        for long-term digital growth.
                    </p>
                </div>
                <div className="row grid md:grid-cols-12 lg:grid-cols-12 place-items-center gap-[84px]">
                    <div className="col-span-full ">
                        <div className="services-listing" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            <div className="row grid md:grid-cols-12 lg:grid-cols-12 overflow-hidden">
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="200"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Strategy</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Consultancy</li>
                                            <li>Ideation</li>
                                            <li>Idea Validation</li>
                                            <li>AI Strategy & Consulting</li>
                                            <li>Product Engineering</li>
                                            <li>Policies</li>
                                            <li>Stakeholders</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="300"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Design</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Concept Development</li>
                                            <li>Prototyping</li>
                                            <li>Usability</li>
                                            <li>User Validation</li>
                                            <li>User Interface (UI) Design</li>
                                            <li>User Experience (UX) Design</li>
                                            <li>AI-Powered UX Research & Predictive Usability Analysis</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="400"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Development</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>AI and ML Development</li>
                                            <li>Data Engineering & MLOps Integration</li>
                                            <li>Enterprise Software Development</li>
                                            <li>System Integrations</li>
                                            <li>IoT Solutions</li>
                                            <li>Native & Hybrid Mobile Apps</li>
                                            <li>Website & Web Apps</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="500"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Support</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Proactive Monitoring</li>
                                            <li>Server Maintenance</li>
                                            <li>Test Strategies</li>
                                            <li>Dedicated Support</li>
                                            <li>AI Security, Governance </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SpecializedSection;
